import { render, staticRenderFns } from "./TotalKwhPerDay.vue?vue&type=template&id=a4f3bc50&"
import script from "./TotalKwhPerDay.vue?vue&type=script&lang=ts&"
export * from "./TotalKwhPerDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports